import React, { Component } from 'react';
import { Button } from 'reactstrap';
import { connect } from 'react-redux';
import { login } from '../redux/Action'
import Axios from 'axios';
import { Link, Redirect } from 'react-router-dom';
import { API_URL } from '../API_url/API_URL';

class register extends Component {
    state = { 
        loading: false,
        error: false,
        char: false,
        spec: false,
        num: false,
        show: false,
        border: false
     }

    onBtnSignIn = () => {
        let {char, spec, num} = this.state
        let username = this.refs.username.value
        let email = this.refs.username.value
        let password = this.refs.password.value
        let confirmPass = this.refs.confirm.value
        if(char === false && spec === false && num === false){
            alert('Invalid Password')   
        }else if(username && email && password && confirmPass){
            if(password === confirmPass && char === true && num === true){
                Axios.get(API_URL +`/users?username=${username}`)
                .then((res) => {
                    if(res.data.length === 0){
                        Axios.post(API_URL +`/users`, {
                            username,
                            password,
                            email,
                            role: 'user'
                        })
                        document.getElementById('success').innerHTML = "Congratulation!, You have been registered" 
                    }else{
                        alert('Username has been taken')
                    }
                })
            }else{
                alert('Invalid Password')
            }
        }else{
            alert('please fill all forms!')
        }
    }

    handleChange = (e) => {
        let pass = e.target.value
        let num = /[0-9]/
        let spec = /[!@#$%^&*;]/
        this.setState({
            num: num.test(pass), 
            spec: spec.test(pass), 
            char: pass.length > 7,
            border: (num.test(pass) && spec.test(pass) && (pass.length > 7))
        })
    }

    showReq = () => {
        this.setState({show: true})
    }



    render(){
        let { char, num, spec, border, show } = this.state
        if(this.props.username !== ''){
            return (<Redirect to='/'>

            </Redirect>
            )
        }
        return(
            <div className='container'>
                <div className='d-flex justify-content-center'>
                    <form className='box'>
                    <div className='p-5'>
                        <h1 style={{textAlign:"center"}}>Join Us!</h1>
                    <input type='text' ref='username' className='form-control mt-3' placeholder='Username'/>
                    <input type='text' ref='email' className='form-control mt-3' placeholder='Email'/>
                    <input type='password' ref='password' className='form-control mt-3' placeholder='Password' onChange={this.handleChange} onFocus={this.showReq} style={{borderColor: border ? 'green' : 'red'}}/>
                    <input type='password' ref='confirm' className='form-control mt-3' placeholder='Confirm Password' onChange={this.handleChange} onFocus={this.showReq} style={{borderColor: border ? 'green' : 'red'}}/>
                    <div className='d-flex justify-content-center'>
                        <Button  onClick={this.onBtnSignIn} color="success">
                            Register
                        </Button>
                    </div>
                    {
                        show
                        ?
                        <div>
                            {
                                char
                                ?
                                <div style={{color: 'green'}}>
                                    Password length must be 8 or more characters
                                </div>
                                :
                                <div style={{color: 'red'}}>
                                    Password length must be 8 or more characters
                                </div>
                            }
                            {
                                spec
                                ?
                                <div style={{color: 'green'}}>
                                    Password must include special characters
                                </div>
                                :
                                <div style={{color: 'red'}}>
                                    Password must include special characters
                                </div>
                            }
                            {
                                num
                                ?
                                <div style={{color: 'green'}}>
                                    Password must include number
                                </div>
                                :
                                <div style={{color: 'red'}}>
                                    Password must include number
                                </div>
                            }
                        </div>
                        :
                        null
                        }
                    
                    </div>
                    <div id="success" className='d-flex justify-content-center'></div>
                    <div className='d-flex justify-content-center'>
                        <p className='mt-3 desc'>
                            Already have an Account? 
                            <Link to='/login'>
                                <span style={{textDecoration : "underline"}}> Login! </span>
                            </Link>
                        </p>
                    </div>
                    </form>
                </div>

            </div>
         );
    }
}

const mapStatetoProps = ({auth}) => {
    return {
        username: auth.username,
        role: auth.role
    }
}

export default connect(mapStatetoProps, { login })(register)